import classnames from 'classnames';
import React from 'react';

import SkuStore from '@/stores/sku';

import Batch from './batch';
import Discount from './discount';

import './index.less';

interface PropTypes {
  price: PriceTypes.Root;
  i18n: { [key: string]: string };
  moq: number;
  newBuyerActivityText?: string;
}

export default function Product(props: PropTypes & PriceTypes.Countdown) {
  const { price, i18n, moq, newBuyerActivityText } = props;
  const skuInfo = SkuStore(state => state.product);
  const { quantity, isSoldOut } = skuInfo;

  const {
    productLadderPrices,
    formatFixedPrice,
    unitEven,
    productRangePrices,
    unit,
    formatPromotionFixedPrice,
  } = price;
  const renderPrice = () => {
    // 促销价格
    if (formatPromotionFixedPrice) {
      return (
        <div className="promotion-price">
          <strong>{formatPromotionFixedPrice}</strong>
          <span className="promotion-unit">/ {unit}</span>
          <span className="promotion-moq">
            {moq} {moq > 1 ? unitEven : unit}
          </span>
          <span className="promotion-min">{i18n['detailRelatedProducts.minOrder']}</span>
          <p>
            <del>{formatFixedPrice}</del>
          </p>
        </div>
      );
    }

    // 区间价
    if (productRangePrices) {
      const { priceRangeText, pricePromotionRangeText } = productRangePrices;
      return (
        <div className="price-range">
          <div className="min-moq">
            {i18n['detail_pc_moq_explanation']} {moq} {moq > 1 ? unitEven : unit}
          </div>
          {pricePromotionRangeText && (
            <>
              <span className="promotion">{pricePromotionRangeText}</span>
              <span className="del">{priceRangeText}</span>
            </>
          )}
          {!pricePromotionRangeText && <span className="price">{priceRangeText}</span>}
        </div>
      );
    }

    // 阶梯价
    if (productLadderPrices) {
      return productLadderPrices.map((item: any, index: number) => (
        <div className="price-item" key={index}>
          {item.max === -1 ? (
            <div className="quality">
              &gt;= {item.min} {unitEven}
            </div>
          ) : (
            <div className="quality">
              {item.min} - {item.max} {unitEven}
            </div>
          )}
          <div className="price">
            {item.formatPromotionPrice && (
              <span
                className={classnames({
                  promotion:
                    (quantity > 0 && quantity <= moq && index === 0) ||
                    (quantity >= item.min && quantity <= item.max) ||
                    (quantity >= item.min && item.max === -1),
                })}
              >
                {item.formatPromotionPrice}
              </span>
            )}
            {item.formatPromotionPrice && <span>{item.formatPrice}</span>}
            {!item.formatPromotionPrice && (
              <span
                className={classnames({
                  promotion:
                    (quantity > 0 && quantity <= moq && index === 0) ||
                    (quantity >= item.min && quantity <= item.max) ||
                    (quantity >= item.min && item.max === -1),
                })}
              >
                {item.formatPrice}
              </span>
            )}
          </div>
        </div>
      ));
    }

    return (
      <div className="promotion-price">
        <div className="min-moq">
          {i18n['detail_pc_moq_explanation']} {moq} {moq > 1 ? unitEven : unit}
        </div>
        <strong className="normal">{formatFixedPrice}</strong>
      </div>
    );
  };

  return (
    <div
      className={classnames({
        'product-price': true,
        'new-buyer': !!newBuyerActivityText,
      })}
    >
      <Discount {...props} />
      <Batch {...props} />
      <div className="price-list">
        {newBuyerActivityText && (
          <div
            className="new-buyer"
            dangerouslySetInnerHTML={{
              __html: newBuyerActivityText,
            }}
          />
        )}
        {renderPrice()}
      </div>
      {isSoldOut && <div className="sold-out">{i18n['notice.content.wuhan']}</div>}
    </div>
  );
}
